<h1>Actualización Base de Datos</h1>
<div class="mat-elevation-z4 divmarco">
  <form [formGroup]="actualizarBDForm" (ngSubmit)="onSubmit()">
    <h1>Ingrese la nueva Base de datos</h1>
    <hr>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Indique nombre de archivo a cargar" appearance="outline"
          class="input-width-350" floatLabel="always">
          <mat-label>Nombre de Archivo:</mat-label>
          <input matInput formControlName="nombreArchivo" name="nombreArchivo" minlength="4" maxlength="50"
            autocomplete="off" required>
          <mat-icon matSuffix>storage</mat-icon>
          <mat-error *ngIf="actualizarBDForm.controls['nombreArchivo'].hasError('required')">Nombre es requerido.
          </mat-error>
          <mat-error *ngIf="actualizarBDForm.controls['nombreArchivo'].hasError('minlength')">Nombre debe ser mínimo 4
            caracteres.
          </mat-error>
          <mat-error *ngIf="actualizarBDForm.controls['nombreArchivo'].hasError('pattern')">Nombre de archivo inválido.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start start" class="divconten">
      <p style="font-weight: bold;" fxLayout="column">Recuerde lo siguiente:</p>
      <p>-&nbsp;El archivo de la base de datos ya debe estar cargado.</p>
      <p>-&nbsp;El nombre indicado debe coincidir con el nombre del archivo cargado.</p>
      <p>-&nbsp;El nombre indicado debe contener una de las siguientes extensiones: .mdb, .accdb</p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="divconten">
      <p style="font-weight: bold;">(*) Estos campos son obligatorios.</p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
  class="divconten">
  <div fxLayout="column">
      <button mat-raised-button (click)="navigateMenu('home');" color="warn" type="button" class="align-center-middle">
        <span class="text-icon-space">Regresar a Home</span>
        <mat-icon>home</mat-icon>
      </button>
    </div>
    <div fxLayout="column">
      <button mat-raised-button color="primary" type="submit" class="align-center-middle">
        <span class="text-icon-space">Actualizar</span>
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  </form>
</div>